import React from "react";
import { Organization } from "../../../models/interfaces/organization";
import { AvailableLimits } from "../../../utilities/organization-util";
import { Modal } from "../../modal/modal";
import { EditSubOrganizationForm } from "../edit-sub-organization-form/edit-sub-organization-form";

type SubOrganizationModalProps = {
    open: boolean;
    onClose: () => void;
    /** Modal heading; add and edit differ only in copy. */
    title: string;
    /** When set the form edits that sub-organization; otherwise it creates one. */
    organizationId?: string;
    /** Pre-loaded organization for edit mode; skips the fetch and prevents flashing create-mode values. */
    organization?: Organization;
    /** Pre-loaded parent (head) organization for instant display. */
    parentOrganization?: Organization;
    /** Pre-computed remaining capacity for instant display. */
    availableLimits?: AvailableLimits;
    onSaved?: () => void;
};

/**
 * Shared create/edit modal for sub-organizations, built on the shared Modal.
 * The form owns its fields and actions (Cancel / Add Sub-Organization / Save).
 */
export const SubOrganizationModal: React.FC<SubOrganizationModalProps> = (props: SubOrganizationModalProps) => {
    const {
        open,
        onClose,
        title,
        organizationId,
        organization,
        parentOrganization,
        availableLimits,
        onSaved,
    } = props;

    return (
        <Modal
            isOpen={open}
            isLoading={false}
            onClose={() => onClose()}
            title={title}
            size="narrow">
            <EditSubOrganizationForm
                hideTitle
                organizationId={organizationId}
                organization={organization}
                parentOrganization={parentOrganization}
                availableLimits={availableLimits}
                onSave={onSaved}
                onCancel={onClose}
            />
        </Modal>
    );
};
